import { render, staticRenderFns } from "./MonitoringColumn.vue?vue&type=template&id=6ad4854b&scoped=true"
import script from "./MonitoringColumn.vue?vue&type=script&lang=js"
export * from "./MonitoringColumn.vue?vue&type=script&lang=js"
import style0 from "./MonitoringColumn.vue?vue&type=style&index=0&id=6ad4854b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4854b",
  null
  
)

export default component.exports